(function(){
  var KEY='se_theme_mode';
  var root=document.documentElement;

  function getStored(){try{return localStorage.getItem(KEY);}catch(e){return null;}}
  function setStored(v){try{localStorage.setItem(KEY,v);}catch(e){}}

  function apply(theme){
    if(theme!=='dark'&&theme!=='light') theme='light';
    root.dataset.theme=theme;
    setStored(theme);
  }

  function init(){
    var stored=getStored();
    if(stored==='dark'||stored==='light') apply(stored);
    else{
      var prefersDark=false;
      try{prefersDark=window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches;}catch(e){}
      apply(prefersDark?'dark':'light');
    }

    document.addEventListener('click',function(e){
      var btn=e.target&&e.target.closest?e.target.closest('[data-se-theme-toggle] [data-se-theme]'):null;
      if(!btn) return;
      e.preventDefault();
      apply(btn.getAttribute('data-se-theme'));
    },{passive:false});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
